﻿import {nanoid} from "@2d-front-monorepo/core";
import {Children, Context, createContext, JSX, ReactElement, ReactNode, useMemo} from "react";

export type FilterComponentProps = {
	label: string;
	title: string;
	children: ReactNode;
}

export type FilterManagerProps = {
	title: string;
	children: ReactElement<FilterComponentProps> | ReactElement<FilterComponentProps>[];
}

export function FilterEntry(props: FilterComponentProps): JSX.Element {
	return <>{props.children}</>;
}

export type FilterPopoverContextProps = {
	close: () => void;
}

export const FilterPopoverContext:Context<FilterPopoverContextProps | null> = createContext<FilterPopoverContextProps | null>(null);

function FilterPopOver({id, anchorId, title, children, onClose}: {
	id: string,
	anchorId: string,
	title: string,
	children: ReactNode,
	onClose?: () => void
}): JSX.Element {
	const handleClose = () => {
		document.getElementById(id)?.hidePopover();
		onClose?.();
	};

	return <FilterPopoverContext.Provider value={{close: handleClose}}>
		<div popover="auto" id={id} anchor={anchorId} className="popover-dialog">
			<div className="popover-dialog__header">{title}</div>
			<div className="popover-dialog__content">{children}</div>
		</div>
	</FilterPopoverContext.Provider>
}

export function FiltersComponent(props: FilterManagerProps): JSX.Element {
	const {title, children} = props;
	const items = (Children.toArray(children) as React.ReactElement<FilterComponentProps>[]);
	const filterIds = useMemo(() => items.map(() => "filter_" + nanoid()), [items.length]);
	const targetIds = useMemo(() => items.map(() => "filter_target_" + nanoid()), [items.length]);

	return (
		<>
			<details className="filters">
				<summary>{title}</summary>
				<div className="layout horizontal gap filters__contents">
					{items.map((item, index) => {
						return (<button key={filterIds[index]}
						                className="form__button form__button--small"
						                type="button" id={filterIds[index]}
						                popoverTarget={targetIds[index]}>
							{item.props.label}
						</button>)
					})}
				</div>
				{items.map((item, index) => {
					return <FilterPopOver key={index}
					                      id={targetIds[index]}
					                      anchorId={filterIds[index]}
					                      title={item.props.title}
					                      children={item.props.children}/>
				})}
			</details>
		</>
	)
}
